import { render, staticRenderFns } from "./sixth.vue?vue&type=template&id=c55073ce&scoped=true&"
import script from "./sixth.vue?vue&type=script&lang=js&"
export * from "./sixth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55073ce",
  null
  
)

export default component.exports